import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Util from "../../../Classes/Utils";
import { Global } from "../../Variables/Global";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { toast } from "react-toastify";
import {
  GetCountriesWithCities,
  GetOrderAddressBookByAddressType,
} from "../../Data";
import Cookies from "js-cookie";

const AddressBook = (props) => {
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [Notes, setNotes] = useState("");
  const [key, setKey] = useState("home");
  const [addressBook, setAddressBook] = useState("");
  const [cityId, setCityId] = useState("");
  const [addBool, setAddBool] = useState(false);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("");
  const [filteredCities, setFilteredCities] = useState([]);
  const [countryCode, setCountryCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const token = Cookies.get("CustomerToken");
  const navigate = useNavigate();

  const getCountries = () => {
    GetCountriesWithCities(token).then((res) => {
      setCountries(res);
      getAddressBookDetailsHome(res);
    });
  };

  const getAddressBookDetailsHome = (res) => {
    const getItem = Cookies.get("Number") !== undefined;
    if (Cookies.get("Number") !== undefined) {
      var CustomerId = Cookies.get("Number");
      setAddress1("");
      setAddress2("");
      setEmail("");
      setLastName("");
      setFirstName("");
      setPhoneNumber("");
      setCity("");
      setAddressBook("");
      setCountry("");
      GetOrderAddressBookByAddressType(key, CustomerId, token)
        .then((Result) => {
          setAddressBook(Result);
          setAddress1(Result.Address1);
          setAddress2(Result.Address2);
          setFirstName(Result.FirstName);
          setLastName(Result.LastName);
          setPhoneNumber(Result.PhoneNumber);
          setEmail(Result.Email);
          setCountry(Result.State);
          const filteredCountries = res.filter((i) => i.CountryName === Result.State);
          setFilteredCities(filteredCountries[0].Cities);
          setCity(Result?.CityName);
          if (Result?.CityId) {
            fetch(
              Global.API_URL + "Country/GetCitiyNameById/" + Result.CityId,
              {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": Global.API_URL,
                },
              }
            )
              .then((response) => {
                return response.json();
              })
              .then((Result) => {
                setCity(Result[0].CityName);
                const value = Result[0].CityId;
                setCityId(value);
                if (Result[0].CountryCode === "UAE") {
                  setCountry("United Arab Emirates");
                  const filteredCountries = res?.filter(
                    (i) => i.CountryName === "United Arab Emirates"
                  );
                  setFilteredCities(filteredCountries[0]?.Cities);
                } else if (Result[0].CountryCode === "LB") {
                  setCountry("Lebanon");
                  const filteredCountries = res?.filter(
                    (i) => i.CountryName === "Lebanon"
                  );
                  setFilteredCities(filteredCountries[0]?.Cities);
                }
              });
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  const HandleSubmitAddress = () => {
    var CustomerId = Cookies.get("Number");
    const countryCode =
      country === "United Arab Emirates" ? "UAE" :
        country === "Lebanon" ? "LB" :
          null;


    fetch(Global.API_URL + "AddressBook/AddAddressBook", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        CustomerId: CustomerId,
        FirstName: FirstName,
        LastName: LastName,
        Email: Email,
        PhoneNumber: PhoneNumber,
        Address1: Address1,
        Address2: Address2,
        CityName: city,
        IsDefault: false,
        IsSamePerson: true,
        IsSameShippingAddress: false,
        CountryName: country,
        CountryCode: countryCode,
        PostalCode: "00000",
        State: country,
        AddressType: key,
      }),
    }).then((response) => {
      if (response.ok) {
        toast.success("Address Book Added");
        return response.json();
      } else throw Error("Did Not Receive expected data");
    });
  };

  const HandleUpdateAddress = () => {
    var CustomerId = Cookies.get("Number");
    fetch(Global.API_URL + "AddressBook/UpdateAddressBook", {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        CustomerId: CustomerId,
        FirstName: FirstName,
        LastName: LastName,
        Email: Email,
        PhoneNumber: PhoneNumber,
        Address1: Address1,
        Address2: Address2,
        CityName: city,
        IsDefault: false,
        IsSamePerson: true,
        IsSameShippingAddress: false,
        CountryName: country,
        CountryCode: countryCode,
        PostalCode: "00000",
        State: "United Arab Emirates",
        AddressType: key,
      }),
    })
      .then((response) => {
        if (response.ok) {
          toast.success("Address Book Updated");
          return response.json();
        } else throw Error("Did Not Receive expected data");
      })
      .catch((error) => {
        toast.error(error);
      });
  };


  const FilterCountries = (e) => {
    const value = e.target.value;
    setCountry(value);
    const filteredCountries = countries.filter((i) => i.CountryName === value);
    // const filteredCountries = countries.filter((x) => {
    // 	return x.Cities.some((Cities) => Cities.CityName === value)
    // });
    setFilteredCities(filteredCountries[0].Cities);
  };

  useEffect(() => {
    getCountries();
    // getAddressBookDetailsHome();


    // getAddressBookDetailsWork();
  }, [key]);

  return (
    <>
      <Tabs
        activeKey={key}
        id="controlled-tab-example"
        className="mb-3"
        onSelect={(k) => setKey(k)}
      >
        <Tab eventKey="home" title="Home">
          <div className="row">
            <div className="col-12">
              <label className="title">Home Address</label>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3 mt-2">
              <label className="infoTitle">Full Name:</label>
            </div>
            <div className="col-9">
              <div className="row">
                <div className="col-6">
                  <input
                    type="text"
                    className="inputBox"
                    value={FirstName}
                    placeholder="First Name"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    className="inputBox"
                    value={LastName}
                    placeholder="Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3 mt-2">
              <label className="infoTitle">Email</label>
            </div>
            <div className="col-9 mt-2">
              <input
                type="email"
                className="inputBox"
                value={Email}
                placeholder="Your Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3 mt-2">
              <label className="infoTitle">Phone Number</label>
            </div>
            <div className="col-9">
              <div className="col-12">
                <PhoneInput
                  placeholder="Type here"
                  value={PhoneNumber}
                  className="inputBox"
                  onChange={setPhoneNumber}
                />
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-12 mb-2">
              <label>Country</label>
              <select
                name="country"
                className="checkout-form input"
                onChange={(e) => FilterCountries(e)}
                value={country}
                required
              >
                <option value="please select country">
                  Please select country
                </option>
                {countries &&
                  countries.map((i, index) => (
                    <option key={index} value={i.CountryName}>
                      {i.CountryName}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-12 mb-2">
              <label>City</label>

              <select
                name="City"
                className="checkout-form input"
                onChange={(e) => setCity(e.target.value)}
                value={city}
                required
              >
                <option value="please select city">Please select city</option>
                {filteredCities &&
                  filteredCities.map((i, index) => (
                    <option key={index} value={i.CityName}>
                      {i.CityName}
                    </option>
                  ))}

              </select>
            </div>
            <div className="row mt-2">
              <div className="col-4 col-md-3 mt-2">
                <label className="infoTitle">Address1:</label>
              </div>
              <div className="col-8 col-md-9 mt-2">
                <input
                  type="text"
                  value={Address1}
                  className="inputBox"
                  placeholder="Type Here"
                  onChange={(e) => setAddress1(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row mt-2 mt-2">
            <div className="col-4 col-md-3 mt-2">
              <label className="infoTitle">Address2:</label>
            </div>
            <div className="col-8 col-md-9 mt-2">
              <textarea
                placeholder="Type Address"
                value={Address2}
                className="form-control textareaBox"
                cols={4}
                rows={3}
                onChange={(e) => setAddress2(e.target.value)}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              {addressBook != "" && addressBook != null ? (
                <button
                  onClick={() => HandleUpdateAddress()}
                  className="register-button mt-0"
                >
                  Update
                </button>
              ) : (
                <button
                  onClick={() => HandleSubmitAddress()}
                  className="register-button mt-0"
                >
                  Submit
                </button>
              )}
            </div>
          </div>
          {/* <div className='d-md-none'>
                        <div className='row'>
                            <div className='col-12'>
                                <button className='editBtn'>Submit</button>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>
                                <button className='outBtn'>Log- out</button>
                            </div>
                        </div>
                    </div> */}
        </Tab>
        <Tab eventKey="work" title="Work">
          <div className="row mt-2">
            <div className="col-12 mt-2">
              <label className="title">Work Address</label>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3 mt-3">
              <label className="infoTitle">Full Name:</label>
            </div>
            <div className="col-9 mt-2">
              <div className="row">
                <div className="col-6">
                  <input
                    type="text"
                    className="inputBox"
                    value={FirstName}
                    placeholder="First Name"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    className="inputBox"
                    value={LastName}
                    placeholder="Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
              {/* <div className='row'>
                                                <div className='col-3'>
                                                    <input type="radio" id="mr" className='inputCheckbox' name='gender' />
                                                    <label for="mr" className='checkLabel ms-2'>Mr.</label>
                                                </div>
                                                <div className='col-3'>
                                                    <input type="radio" id="mrs" className='inputCheckbox' name='gender' />
                                                    <label for="mr" className='checkLabel ms-2'>Mrs.</label>
                                                </div>
                                            </div> */}
            </div>
          </div>
          <div className="row mt-2 mt-2">
            <div className="col-3 mt-2">
              <label className="infoTitle">Email</label>
            </div>
            <div className="col-9 mt-2">
              <input
                type="email"
                className="inputBox"
                value={Email}
                placeholder="Your Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3 mt-3">
              <label className="infoTitle">Phone Number</label>
            </div>
            <div className="col-9 mt-2">
              <div className="col-12 mt-2">
                <PhoneInput
                  placeholder="Type here"
                  className="inputBox"
                  value={PhoneNumber}
                  onChange={setPhoneNumber}
                />
              </div>
            </div>
          </div>

          {/* <div className='row'>
                        <div className='col-4 col-md-3'>
                            <label className='infoTitle'>Country:</label>
                        </div>
                        <div className='col-8 col-md-9'>
                            <select className='inputBoxSelect'>
                                <option className='info' selected disabled>-- Choose a Country --</option>
                                <option className='info'>Country</option>
                            </select>
                        </div>
                    </div> */}
          <div className="col-12 mb-2">
            <label>Country</label>
            <select
              name="country"
              className="checkout-form input"
              onChange={(e) => FilterCountries(e)}
              value={country}
              required
            >
              <option value="please select country">
                Please select country
              </option>
              {countries &&
                countries.map((i, index) => (
                  <option key={index} value={i.CountryName}>
                    {i.CountryName}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-12 mb-2">
            <label>City</label>

            <select
              name="City"
              className="checkout-form input"
              onChange={(e) => setCity(e.target.value)}
              value={city}
              required
            >
              <option value="please select city">Please select city</option>
              {filteredCities &&
                filteredCities.map((i, index) => (
                  <option key={index} value={i.CityName}>
                    {i.CityName}
                  </option>
                ))}
            </select>
          </div>
          <div className="row mt-2">
            <div className="col-4 col-md-3 mt-2">
              <label className="infoTitle">Address1:</label>
            </div>
            <div className="col-8 col-md-9 mt-2">
              <input
                type="text"
                value={Address1}
                className="inputBox"
                placeholder="Type Here"
                onChange={(e) => setAddress1(e.target.value)}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-4 col-md-3 mt-2">
              <label className="infoTitle">Address2:</label>
            </div>
            <div className="col-8 col-md-9 mt-2">
              <textarea
                placeholder="Type Address"
                value={Address2}
                className="form-control textareaBox"
                cols="4"
                rows="3"
                onChange={(e) => setAddress2(e.target.value)}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-4 mt-2"></div>
            <div className="col-md-4 mt-2">
              {addressBook != "" && addressBook != null ? (
                <button
                  onClick={() => HandleUpdateAddress()}
                  className="register-button mt-0"
                >
                  Update
                </button>
              ) : (
                <button
                  onClick={() => HandleSubmitAddress()}
                  className="register-button mt-0"
                >
                  Submit
                </button>
              )}
            </div>
          </div>

          {/* <div className='d-md-none'>
                        <div className='row'>
                            <div className='col-12'>
                                <button className='editBtn'>Submit</button>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>
                                <button className='outBtn'>Log- out</button>
                            </div>
                        </div>
                    </div> */}
        </Tab>
      </Tabs>
    </>
  );
};
export default AddressBook;
